import { Icon, Typography } from "@fullscript/aviary-web";
import { faCheck } from "@fullscript/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import rupaFullscriptCatalogs from "@shared/assets/images/practitionerOnboarding/FullscriptRupa/rupa-fullscript-catalogs.webp";
import { l } from "@unauthenticated/shared/locales/i18n";

import * as styles from "./RupaRedirectInfoPanel.styles";

const VALUE_PROPS = [
  "trustedLabs",
  "phlebotomyOptions",
  "ehrIntegrations",
  "flexibleBilling",
  "authorizeLabs",
] as const;

const RupaRedirectInfoPanel = () => {
  const { t } = useTranslation();

  return (
    <div css={styles.panel}>
      <img
        css={styles.image}
        src={rupaFullscriptCatalogs}
        alt={t(l.common.rupaRedirectInfoPanel.imageAlt)}
      />
      <Typography variant="h5" customCss={styles.title}>
        {t(l.common.rupaRedirectInfoPanel.title)}
      </Typography>
      <ul css={styles.list}>
        {VALUE_PROPS.map(prop => (
          <li key={prop} css={styles.listItem}>
            <Icon icon={faCheck} size="small" customCss={styles.checkIcon} />
            <Typography variant="footnote" isMarginless>
              {t(l.common.rupaRedirectInfoPanel[prop])}
            </Typography>
          </li>
        ))}
      </ul>
    </div>
  );
};

export { RupaRedirectInfoPanel };
